import styled, { css } from "styled-components"
import { colors, device } from "../styles/stylesConfig"
import { useTranslation } from "react-i18next"
import { useLogEvent } from "../hooks/useLogEvent"

const Container = styled.div`
    width: 100%;
    padding: 10vh 10%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: ${colors.dark};
    z-index: 1;

    @media ${device.md} {
        padding: 5vh 10% !important;
    }   

`

const Title = styled.h2`
    font-weight: 700;
    font-size: 38px;
    color: ${colors.primary};
    letter-spacing: 5px;
    line-height: 60px;
    margin-bottom: 50px;
    text-transform: uppercase;
    transition: all 0.3s ease-in-out;
    position: relative;
    text-align: center;

    @media ${device.lg} {
        font-size: 32px;
    }

    @media ${device.md} {
        font-size: 28px;
        margin-bottom: 40px;
    }   

    @media ${device.sm} {
        font-size: 20px;
        line-height: 30px;
    }
`

const DescriptionContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    position: relative;

    @media ${device.sm} {
        gap: 15px;
    }
`

const Description = styled.p`
    width: 100%;
    font-size: 16px;
    color: #fff;
    letter-spacing: 1px;
    font-weight: 300;
    text-align: center;

    @media ${device.lg} {
        font-size: 14px;
    }

    @media ${device.sm} {
        font-size: 12px;
    }
`

const ServicesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 100px;
    margin: 80px 0;
    place-items: center;
    padding: 15px;

    @media ${device.lg} {
        margin: 70px 0;
        gap: 50px;
    }

    @media ${device.md} {
        width: 90%;
        grid-template-columns: 1fr;
        margin: 50px 0;
        gap: 50px;
    }

    @media ${device.sm} {
        margin: 30px 0;
        gap: 30px;
        padding: 10px;
    }
`

const ServiceBox = styled.button<{ src: string }>`
    width: 270px;
    height: 400px;
    border-radius: 10px;
    padding: 20px;
    cursor: pointer;
    position: relative;
    box-shadow: 0px 2px 12px rgba(255, 255, 255, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &::before {
        content: '';
        position: absolute;
        margin: auto;
        width: 100%;
        height: 100%;
        background-color: ${colors.dark};
        opacity: 0.25;
    }

    ${props => props.src && css`
        background: url(${props.src}) center no-repeat;
        background-size: cover;
    `}

    &:hover {
        & > p {
            transform: scale(1.05);
        }
        & > div {
            transform: scale(1.2);
        }
    }

    @media ${device.lg} {
        width: 220px;
        height: 350px;
    }

    @media ${device.md} {
        width: 100%;
        height: 250px;
    }

    @media ${device.sm} {
        height: 150px;
    }
`

const ServiceTitle = styled.p`
    font-size: 20px;
    color: #fff;
    letter-spacing: 3px;
    text-transform: uppercase;
    font-weight: bold;
    transition: all .3s ease;
    z-index: 1;

    @media ${device.lg} {
        font-size: 18px;
    }

    @media ${device.md} {
        font-size: 20px;
    }

    @media ${device.sm} {
        font-size: 12px;
    }
`

interface Props {
    setShowModal: React.Dispatch<React.SetStateAction<{ title: string, description: string } | null>>
}

export const Services = ({ setShowModal }: Props) => {
    const { t } = useTranslation();
    const descriptions: any = t('services.descriptions', { returnObjects: true });
    const data: any = t('services.data', { returnObjects: true });

    return (

        <Container id="services">

            <Title className="utils__fade-in-fast-top">{t('services.title')}</Title>

            <DescriptionContainer>

                {
                    descriptions.map((value: string) => (
                        <Description className="utils__fade-in-fast-top" key={value}>
                            {value}
                        </Description>
                    ))
                }

            </DescriptionContainer>

            <ServicesContainer>

                {
                    data.map((value: any) => (
                        <ServiceBox
                            className="utils__fade-in-fast-center"
                            key={value.title}
                            src={require(`../images/${value.mainImage}`)}
                            onClick={() => {
                                setShowModal({ title: `${value.title} ${value.subtitle}`, description: value.description });
                            }}
                        >
                            <ServiceTitle className="utils__fade-in-bottom" style={{ color: value.titleColor }}>{value.title}</ServiceTitle>
                            <ServiceTitle className="utils__fade-in-top" style={{ color: value.titleColor }}>{value.subtitle}</ServiceTitle>
                        </ServiceBox>
                    ))
                }

            </ServicesContainer>

        </Container >

    )
}

export default Services;